import { render, staticRenderFns } from "./HandleDeliverData.vue?vue&type=template&id=1dd83938&scoped=true"
import script from "./HandleDeliverData.vue?vue&type=script&lang=js"
export * from "./HandleDeliverData.vue?vue&type=script&lang=js"
import style0 from "./HandleDeliverData.vue?vue&type=style&index=0&id=1dd83938&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd83938",
  null
  
)

export default component.exports